const breakpoints = {
  xs: "22rem", // 352px
  sm: "48rem", // 768px
  md: "64rem", // 1024px
  lg: "80rem", // 1280px
} as const

export const mediaQueries = {
  xs: `screen and (max-width: ${breakpoints?.xs})`,
  sm: `screen and (min-width: ${breakpoints?.xs})`,
  md: `screen and (min-width: ${breakpoints?.sm})`,
  lg: `screen and (min-width: ${breakpoints?.md})`,
  xl: `screen and (min-width: ${breakpoints?.lg})`,
  above: {
    xs: `screen and (min-width: 0rem)`,
    sm: `screen and (min-width: ${breakpoints?.sm})`,
    md: `screen and (min-width: ${breakpoints?.md})`,
    lg: `screen and (min-width: ${breakpoints?.lg})`,
  },
  below: {
    xs: `screen and (max-width: ${breakpoints?.xs})`,
    sm: `screen and (max-width: ${breakpoints?.sm})`,
    md: `screen and (max-width: ${breakpoints?.md})`,
    lg: `screen and (max-width: ${breakpoints?.lg})`,
  },
  only: {
    xs: `screen and (max-width: ${breakpoints?.xs})`,
    sm: `screen and (min-width: ${breakpoints?.xs}) and (max-width: ${breakpoints?.sm})`,
    md: `screen and (min-width: ${breakpoints?.sm}) and (max-width: ${breakpoints?.md})`,
    lg: `screen and (min-width: ${breakpoints?.md}) and (max-width: ${breakpoints?.lg})`,
    xl: `screen and (min-width: ${breakpoints?.lg})`,
  },
} as const
